<template>
  <div>
    <a href="#" v-scroll-to="'#html'" :style="style" class="cursor-pointer border border-current py-1 px-3 hover:bg-black hover:text-white inline-block mt-16">{{ $t('footer', 'backToTop') }}</a>
  </div>
</template>

<script>
export default {
  name: 'BaseBackToTop',
  computed: {
    style () {
      return this.$store.state.style
    }
  }
}
</script>
